import React from 'react'
import { useContext } from '../Context'
import { PopUpContainer } from '../../../../components/header/quick-create/PopUpContainer'
import { MenuPopUpEnum } from '../MenuPopUpEnum'
import { AddTask } from '../../../add-task'

export const TaskPopUp = () => {
  const { menuTarget, open, onCloseMenu } = useContext()

  return (
    <PopUpContainer show={menuTarget?.show === MenuPopUpEnum.task && open} target={menuTarget?.target}>
      <AddTask onCloseMenu={onCloseMenu} />
    </PopUpContainer>
  )
}
